import queryString from "query-string";

import Service from "shared/payment/services";

import {
	openCreditCard as paymentOpenCreditCard,
	setProducts as paymentSetProducts,
} from "ducks/payment";

import {
	PRODUCT_TYPES,
	PRODUCT_SUBTYPES,
} from "shared/payment/constants";


// action types
// ----------------------------------------------------------------------------

export const LOAD = "incognitoPackages.LOAD";
export const SET_SELECTED_PRODUCT_PACKAGE = "incognitoPackages.SET_SELECTED_PRODUCT_PACKAGE";
export const SET_PRODUCT_PACKAGES = "incognitoPackages.SET_PRODUCT_PACKAGES";
export const OPEN_PAYMENT_MODAL = "incognitoPackages.OPEN_PAYMENT_MODAL";
export const TOGGLE_MODAL_VISIBILITY = "incognitoPackages.TOGGLE_MODAL_VISIBILITY";


// initial state
// ----------------------------------------------------------------------------

export const INITIAL_STATE = {
	productPackages: [],
	isLoading: true,
	isPurchased: false,
	hasDiscount: false,
	isVisible: false,
	type: "inline",
};

const getInitialState = () => {
	if (typeof window !== "undefined" && window.IncognitoParams) {
		return { ...INITIAL_STATE, ...window.IncognitoParams };
	} else {
		return INITIAL_STATE;
	}
};


// reducer
// ----------------------------------------------------------------------------

export function reducer(state = getInitialState(), action) {
	switch (action.type) {
		case SET_PRODUCT_PACKAGES: {
			return {
				...state,
				productPackages: action.payload.productPackages,
				isLoading: false,
			};
		}

		case OPEN_PAYMENT_MODAL: {
			return state;
		}

		case TOGGLE_MODAL_VISIBILITY: {
			return {
				...state,
				isVisible: action.payload.isVisible,
			};
		}

		default: {
			return state;
		}
	}
}


// action creators
// ----------------------------------------------------------------------------

export const loadPage = () => ({ type: LOAD });

export const setProductPackages = (productPackages) => ({
	type: SET_PRODUCT_PACKAGES,
	payload: {
		productPackages,
	},
});

export const fetchProductPackages = () => (dispatch) => {
	Service.getProductPackages({
		productType: PRODUCT_TYPES.SUBSCRIPTION,
		productSubtype: PRODUCT_SUBTYPES.INCOGNITO,
	})
		.then(({ productPackages }) => {
			dispatch(setProductPackages(productPackages));
		});
};

export const openPayment = (productid) => (dispatch, getState) => {
	const { productPackages } = getState().incognitoPackages;
	const selected = productPackages.filter((product) => productid === product.id)[0];
	dispatch({ type: OPEN_PAYMENT_MODAL, payload: selected });
	dispatch(paymentSetProducts(productPackages));
	dispatch(paymentOpenCreditCard(selected));
};

export const openPaymentMobile = (productid) => (dispatch) => {
	// redirect to a thing
	const qs = {
		productid,
		type: PRODUCT_SUBTYPES.INCOGNITO,
	};

	window.location.href = `/payments?${queryString.stringify(qs)}`;

	dispatch({ type: OPEN_PAYMENT_MODAL });
};

export const toggleModalVisibility = (isVisible) => ({
	type: TOGGLE_MODAL_VISIBILITY,
	payload: {
		isVisible,
	},
});



// WEBPACK FOOTER //
// ./src/ducks/incognito_packages.js